import React from "react";
import wrapComponentWithPopup from "../../wrapComponentWithPopup";
import { PopupProps } from "../../wrapComponentWithPopup/wrapComponentWithPopup";
import RedirectButton from "../../RedirectButton";
import { Path } from "../../../../types/Path";

interface OwnProps {
  onClickSubscribe(): void;
}

type Props = PopupProps & OwnProps;

class RedirectWarning extends React.PureComponent<Props, {}>  {
  render() {
    return (
      <div className="component--redirect-warning-popup">
        <div className="top">
          <div className="text">The current project will not be saved and all the changes will be lost. Would you like to continue?</div>
          <div className="top-separator" />
          <div className="buttons-container">
            <button className="cancel" onClick={this.props.closePopup}>cancel</button>
            <RedirectButton path={Path.Home} text="Continue" classes="continue" />
          </div>
        </div>

        <div className="separator"><div className="circle">Or</div></div>

        <div className="subscribe-message">Once you create an account, all your projects will be automatically saved on your dashboard.</div>
        <RedirectButton path={Path.Subscribe} text="Subscribe" classes="subscribe" onClick={this.props.onClickSubscribe} />
      </div>
    );
  }
}

export default wrapComponentWithPopup(RedirectWarning);
